module.exports = __webpack_public_path__ + "media/images/flags/1x1/tun-529affb556544a5eaa927a59cc097b47.svg";